module.exports = __webpack_public_path__ + "static/media/logo-img.9ae10c41.svg";